import {IFilter} from '@/store/types/IRootState';
import { IItemProperty } from '@/store/types/ItemProperty';


const FilterServiceBase = {
    getters: {
        getNumberOfRemainingFilters: (filters: IFilter[], numberFiltersToShow: number): number => {
            return filters.length - numberFiltersToShow;
        },
        getNFilters: (filters: IFilter[], numberFiltersToShow: number, showAllFilters: boolean): IFilter[] => {
            return showAllFilters === true ?
                filters : filters.slice(0, numberFiltersToShow);
        },
        getCheckedFilters: (filters: IFilter[]): IFilter[] => {
            return filters.filter((filter: IFilter) => filter.checked)
                .reduce(
                    (previousValues: any, current: any) => previousValues.concat(current),
                    [],
                );
            },
        hasFilters: (filters: IFilter[]): boolean => {
            return filters.length > 0;
        },
    },
     mutations: {
        cleanFilters: (filters: IFilter[]) => {
            filters = [];
        },
        checkFilter: (filters: IFilter[], filterValue: string) => {
            const filterFound = filters
            .filter((currentFilter: IFilter) => currentFilter.value === filterValue)[0];
            if (filterFound) { filterFound.checked = !filterFound.checked; }
        },
        populateFilters: (items: IItemProperty[], filterType: string) => {
            const filters: IFilter[] = [];
            let showAllFilters: boolean = true;
            items.forEach((item: any) => {
                item[filterType].forEach((element: any) => {
                    const filterFound = filters
                        .find((filter: IFilter) => filter.name === element.name);
                    if (filterFound) { // encontrou
                        filterFound.count += 1;
                    } else {
                        const filterBuffer = {
                            type: filterType,
                            checked: false,
                            name: element.name,
                            value: element.value,
                            count: 1,
                        };
                        filters.push(filterBuffer);
                        if (filters.length > 5) {
                            showAllFilters = false;
                        }
                    }
                });
            });
            filters.sort((a: any, b: any) => b.count - a.count);
            return {filters, showAllFilters, showFilterGroup: true};
        },
        toggleShowAllFiltersFlag: (showAllFiltersFlag: boolean): boolean => {
            return !showAllFiltersFlag;
        },
        toggleShowFilterGroupFlag: (showFilterGroupFlag: boolean): boolean => {
            return !showFilterGroupFlag;
        },
     },
};

export default FilterServiceBase;
